module.exports = __webpack_public_path__ + "static/media/WITH FLAP X3.44b446af.svg";